module.exports = __webpack_public_path__ + "static/media/promo-center.f74ffd35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/promo-center.jpg
// module id = 1185
// module chunks = 0